<template>
  <div>
    <SerialPack :url="url" cur-class="super_serial_pack3" />
  </div>
</template>

<script>
import SerialPack from '@/views/config/activity-auxiliary/serialPack.vue'
export default {
  name: 'SuperSerialPack3',
  components: {
    SerialPack
  },
  data() {
    return {
      url: '/config/activity-auxiliary/superSerialPack3'
    }
  }
}
</script>

<style scoped>

</style>
